import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { GeneralService } from '../../service/general.service';
import { SidebarService } from '../../service/sidebarservice.service';


@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './navbar.html',
  styleUrls: ['./navbar.scss']
})
export class Navbar implements OnInit {

  private router = inject(Router);
  sidebar = inject(SidebarService);
  private generalService = inject(GeneralService);

  usuario = signal<string>('Admin');
  usuarioId = signal<string>('No disponible');
  licenciaDescripcion = signal('Licencia');
  initials = computed(() => {
    const parts = this.usuario()
      .split(' ')
      .filter(Boolean)
      .slice(0, 2);

    return parts.map(part => part.charAt(0).toUpperCase()).join('') || 'AD';
  });

  ngOnInit(): void {

    const savedUser = localStorage.getItem('authUser');

    if (savedUser) {
      const user = JSON.parse(savedUser);
      this.usuario.set(user.nombre);
      if (user.pkUsuario !== undefined && user.pkUsuario !== null) {
        this.usuarioId.set(String(user.pkUsuario));
      }
    }
    this.generalService.get('GET_LICENCIA').subscribe({
      next: res => {
        if (res && res.length > 0 && res[0].valor) {
          this.licenciaDescripcion.set(res[0].valor);
        }
      },
      error: () => {
        // fallback silencioso
        this.licenciaDescripcion.set('Cargando Licencia...');
      }
    });

  }

  toggleSidebar() {
    this.sidebar.toggleOpen();
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }

  logout() {
    localStorage.removeItem('authUser');
    sessionStorage.clear();
    this.router.navigate(['/signin']);
  }
}
